<template>
    <el-dialog v-dialogDrag :close-on-click-modal=false title="棋招解析" :visible.sync="analysisVisible" fullscreen>
		<el-form ref="analysis" :model="analysis" label-width="100px">
			<el-form-item label="数据来源" prop="orderCompanyId">
				<el-select v-model="analysis.rule" placeholder="请选择数据来源" filterable @change="sourceChange">
					<el-option key="" label="请选择数据来源" value=""></el-option>
					<el-option v-for="item in sourceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" @click="analysisData" icon="el-icon-refresh" v-prevent-re-click>解 析</el-button>&nbsp;&nbsp;&nbsp;
				<el-button type="warning" @click="deleteAnalysisData" icon="el-icon-delete" v-prevent-re-click>批量删除</el-button>
				<el-button type="warning" @click="clearAnalysisDataRemark" icon="el-icon-brush" v-prevent-re-click>批量清理备注</el-button>
				<div style="width:120px;float:right">记录总数：{{resultData.length}}</div>
			</el-form-item>
			<el-row>
				<el-col :span="leftColSize" style="padding-right:20px" v-if="sourceVisible">
					<div class="leftBox" style="height:600px;position:absolute"><textarea ref="leftNum" wrap="off" cols="2" id="leftNum" disabled></textarea></div>
					<textarea
						@input="handleTextareaInput"
						v-model="analysis.source"
						onscroll="document.getElementById('leftNum').scrollTop = this.scrollTop;"
						spellcheck="false"
						ref="sourceTextArea"
						class="area-content" style="height:600px;padding-left:45px;"></textarea>
				</el-col>
				<el-col :span="rightColSize">
					<div>
						<div class="spiltBar" @click="spiltBarClick">
							<img src="../../assets/img/left.png" width="8px" v-if="this.sourceVisible">
							<img src="../../assets/img/right.png" width="8px" v-if="!this.sourceVisible">
						</div>
						<el-table
							:data="resultData"
							:key="editEnable"
							border
							class="table"
							ref="analysisTable"
							header-cell-class-name="table-header"
							@cell-dblclick="tableDoubleClick"
							:cell-style="{padding:4+'px'}"
							height="600px"
							stripe
							@selection-change="handleSelectionAnalysisChange"
						>
							<el-table-column type="selection" width="50" align="center"></el-table-column>
							<el-table-column prop="chessPlayer" label="棋手">
								<template slot-scope="scope">
									<el-input
									  v-if="scope.row.edit"
									  v-model="scope.row.chessPlayer"
									  placeholder="棋手"
									></el-input>
									<span v-else>{{ scope.row.chessPlayer }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="productName" label="棋子">
								<template slot-scope="scope">
									<el-input
									  v-if="scope.row.edit"
									  v-model="scope.row.productName"
									  placeholder="棋子"
									></el-input>
									<span v-else>{{ scope.row.productName }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="demandType" label="类型">
								<template slot-scope="scope">
									<el-select v-model="scope.row.demandType" placeholder="需求类型" v-if="scope.row.edit">
										<el-option key="" label="请选择需求类型" value=""></el-option>
										<el-option key="询价" label="询价" value="询价"></el-option>
										<el-option key="常用" label="常用" value="常用"></el-option>
										<el-option key="买过" label="买过" value="买过"></el-option>
										<el-option key="常备" label="常备" value="常备"></el-option>
										<el-option key="不备货" label="不备货" value="不备货"></el-option>
										<el-option key="报价" label="报价" value="报价"></el-option>
									</el-select>
									<span v-else>
										<el-tag :type= "scope.row.demandType == '报价'?'danger':(scope.row.demandType == '询价'?'success':'info')">{{scope.row.demandType}}
										</el-tag>
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="demandNum" label="数量">
								<template slot-scope="scope">
									<el-input
									  v-if="scope.row.edit"
									  v-model="scope.row.demandNum"
									  placeholder="数量"
									></el-input>
									<span v-else>{{ scope.row.demandNum }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="价格">
								<template slot-scope="scope">
									<el-input
									  v-if="scope.row.edit"
									  v-model="scope.row.price"
									  placeholder="价格"
									></el-input>
									<span v-else>{{ scope.row.price }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="remark" label="备注">
								<template slot-scope="scope">
									<el-input type=textarea :rows=3
									  v-if="scope.row.edit"
									  v-model="scope.row.remark"
									  placeholder="备注"
									></el-input>
									<span v-else>{{ scope.row.remark }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="时间" width="155px">
							</el-table-column>
							<el-table-column label="操作" width="125" align="center">
								<template slot-scope="scope">
									<el-button
										type="text"
										icon="el-icon-edit"
										v-if="scope.row.edit==undefined||scope.row.edit==false"
										@click="handleRowEdit(scope.$index, scope.row)"
									>编辑</el-button>
									<el-button
										type="text"
										icon="el-icon-check"
										v-if="scope.row.edit"
										@click="handleRowSave(scope.$index, scope.row)"
									>保存</el-button>
									<el-button
										type="text"
										icon="el-icon-close"
										v-if="scope.row.edit"
										@click="handleRowCancel(scope.$index, scope.row)"
									>取消</el-button>
									<el-button
										type="text"
										icon="el-icon-delete"
										class="red"
										v-if="scope.row.edit==undefined||scope.row.edit==false"
										@click="handleRemove(scope.$index, scope.row)"
									>删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-progress :percentage="progressAge"></el-progress>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="analysisVisible = false">关 闭</el-button>
			<el-button type="primary" @click="saveBatch" v-prevent-re-click>提 交</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {saveChessDemandBatch, deleteChessDemand, getChessDemand, getAllProducts, getChessRegular, getChessRegularKV, getEnumByCode } from '../../api/index';
export default {
    name: 'ChessDemand',
    data() {
        return {
			multipleSelectionAnalysis:[],
			sourceKV:[],
			resultData:[],
			rowBackUp:{},
			analysis:{},
			currentRegular:{},
			editEnable:false,
			scrollTop:0,
			demandTypeCode:1022,
			demandTypeDatas:[],
			demandTypeMapping:{},
			demandTypeRegular:"(?<demandType>%s)",
			currentDemandType:"",
			sourceVisible:true,
			leftColSize:10,
			rightColSize:14,
			currentSourceId:"",
			ignorePlayerCode:1024,
			ignorePlayer:[],
			currentRegularType:2,
			isSupportReplay:true,
			progressAge:0,
			progressMax:0,
			submitResultData:[],
			quantityPerTime:80,
			submitIndex:0,
			analysisVisible:false,
			key:undefined,
			keys:[],
			from:"",
			loadingForm:undefined
        };
    },
    created() {
		this.getDemandTypes();
		this.getIgnorePlayers();
		this.getSource();
		window.addEventListener('chessDemandDealProgress', this.progressChange);
    },
	destroyed() {
		window.removeEventListener('chessDemandDealProgress', this.progressChange)
	},
    methods: {
		setAnalysisData(data, from, key, keys) {
			this.analysis = {};
			this.resultData = [];
			this.analysisVisible = true;
			this.analysis.source = data;
			this.key = key;
			this.keys = keys;
			this.from = from;
			this.$nextTick(()=>{
				let lineobj = document.getElementById('leftNum');
				this.setNum(lineobj, this.analysis.source);
			});
		},
		spiltBarClick() {
			this.sourceVisible= !this.sourceVisible;
			this.leftColSize=this.sourceVisible?10:0;
			this.rightColSize=this.sourceVisible?14:24;
		},
		getDemandTypes() {
			getEnumByCode(this.demandTypeCode).then(res => {
				if (res.code == 0) {
					this.demandTypeDatas = res.data;
					this.demandTypeDatas.sort(function(a ,b){
						return b["value"].length - a["value"].length;
					});
					for (var i=0; i<this.demandTypeDatas.length; i++) {
						if (this.demandTypeMapping[this.demandTypeDatas[i].content] == undefined) {
							this.demandTypeMapping[this.demandTypeDatas[i].content] = "";
						} else {
							this.demandTypeMapping[this.demandTypeDatas[i].content] = this.demandTypeMapping[this.demandTypeDatas[i].content] + "|";
						}
						this.demandTypeMapping[this.demandTypeDatas[i].content] = this.demandTypeMapping[this.demandTypeDatas[i].content] + this.demandTypeDatas[i].value;
					}
					for (var item in this.demandTypeMapping) {
						this.demandTypeMapping[item] = this.demandTypeRegular.replaceAll("%s", this.demandTypeMapping[item]);
					}
				} else {
					this.$message.error(`获取需求类型信息失败！` + res.message);
				}
			});
		},
		getIgnorePlayers() {
			getEnumByCode(this.ignorePlayerCode).then(res => {
				if (res.code == 0) {
					for (var i=0; i<res.data.length; i++) {
						this.ignorePlayer.push(res.data[i]["value"]);
					}
				} else {
					this.$message.error(`获取忽略棋手信息失败！` + res.message);
				}
			});
		},
		handleTextareaInput(e) {
			let str = e.target.value;
			let lineobj = document.getElementById('leftNum');
			this.setNum(lineobj, str);
		},
		setNum(lineobj, data) {
			let str = data.replace(/\r/gi, "");
			str = str.split("\n");
			let n = str.length;
			let num = "";
			for (let i = 1; i <= n; i++) {
				if (document.all) {
					num += i + "\r\n";   //判断浏览器是否是IE
				} else {
					num += i + "\n";
				}
			}
			lineobj.value = num;
			num = "";
		},
		//获取产品信息
		getSource() {
			getChessRegularKV().then(res => {
				if (res.code == 0) {
					this.sourceKV = res.data;
				} else {
					this.$message.error(`获取数据来源信息失败！` + res.message);
				}
			})
		},
		//类型匹配
		demandTypeFormat(row, column, cellValue) {
			let statusConfig = {"0":"询价", "1":"常用", "2":"买过","3":"常备","4":"不备货","5":"报价"};
			return statusConfig[cellValue];
		},
		sourceChange(value) {
			this.currentRegular = "";
			if (typeof(value) === "undefined" || value === "" ) {
				return;
			}
			this.currentSourceId = value;
			getChessRegular(value).then(res => {
				if (res.code == 0) {
					this.currentRegular = res.data;
					this.currentRegularType = res.data.regularType;
					this.currentDemandType = (res.data.regularType==0?"报价":"询价");
					this.isSupportReplay = res.data.replay;
				} else {
					this.$message.error(`获取规则匹配信息失败！` + res.message);
				}
			});
		},
		handleRemove(index, row) {
			// 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					this.resultData.splice(index, 1);
                })
                .catch(() => {});
		},
		getTableScollTop() {
			this.scrollTop = this.$refs.analysisTable.bodyWrapper.scrollTop;
		},
		setTableScollTop() {
			setTimeout(() => {
				this.$refs.analysisTable.bodyWrapper.scrollTop = this.scrollTop;
			}, 13)
		},
		handleRowEdit(index, row) {
			this.getTableScollTop();
			this.rowBackUp = {};
			for(var item in row) {
				this.rowBackUp[item] = row[item];
			}
			row.edit = true;
			this.editEnable=true;
			this.setTableScollTop();
		},
		handleRowSave(index, row) {
			row.edit = false;
			this.editEnable=false;
			this.setTableScollTop();
		},
		handleRowCancel(index, row) {
			let isNotChange = true;
			delete row["edit"];
			for(var item in row) {
				isNotChange = this.rowBackUp[item] == row[item];
				if (!isNotChange) {
					break;
				}
			}
			if (isNotChange) {
				row.edit=false;
				this.editEnable=false;
				this.setTableScollTop();
				return;
			}
			this.$confirm('确定要取消修改吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in row) {
						row[item]= this.rowBackUp[item]?this.rowBackUp[item]:"";
					}
					row.edit=false;
					this.editEnable=false;
					this.setTableScollTop();
                })
                .catch(() => {});
		},
        // 多选操作
        handleSelectionAnalysisChange(val) {
            this.multipleSelectionAnalysis = val;
        },
		deleteAnalysisData() {
			const length = this.multipleSelectionAnalysis.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
				for (let i = 0; i < length; i++) {
					let index = this.resultData.indexOf(this.multipleSelectionAnalysis[i]);
					this.resultData.splice(index, 1);
				}
			})
		},
		clearAnalysisDataRemark() {
			const length = this.multipleSelectionAnalysis.length;
			if (length == 0) {
				this.$message.error(`请选择要清理备注的记录！`);
				return;
			}
			this.$confirm('确定要清理选中的记录备注吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
				for (let i = 0; i < length; i++) {
					this.multipleSelectionAnalysis[i].remark = "";
				}
			})
		},
		//解析数据
		analysisData() {
			this.progressAge=0;
			this.resultData=[];
			let rowIndex = 1;
			if (this.analysis.rule == undefined || this.analysis.rule == "") {
				this.$message.error('请选择数据来源');
				return;
			}
			let dataSource = this.analysis.source;
			let currentProduct = "";
			let currentPlayerRegularDataJson = JSON.parse(this.currentRegular.playerRegular);
			let currentProductRegularDataJson = JSON.parse(this.currentRegular.productRegular);
			let date = this.getCurrentDate();
			//循环解析
			while (dataSource) {
				//解析棋手信息
				let playerItem = {};
				let matchData = this.recursionAnalysisPlayer(playerItem, currentPlayerRegularDataJson, dataSource, "main")
				if (matchData == "") {
					break;
				}
				//剔除已匹配棋手信息
				let matchLen = matchData.length;
				dataSource = dataSource.substring(matchLen, dataSource.length);
				
				//定位下一个棋手信息位置
				let index = this.searchPlayerIndex(dataSource, currentPlayerRegularDataJson);
				if (index == -1) {
					index = dataSource.length;
				}
				//两个棋手之间的数据为棋招数据
				let productSource = dataSource.substring(0, index);
				
				//通过\n计算数据所在行，定位数据来源聊天记录所在行
				let array = productSource.split("\n");
				let rowSize = array.length;
				if (rowSize > 0) {
					//记录数据来源的行号
					playerItem["rowStart"] = rowIndex;
					//有n个数据，就有n-1个换行
					rowIndex += rowSize - 1;
					playerItem["rowEnd"] = rowIndex - 1;
				}
				
				let isIgnorePlayer = this.ignorePlayer.indexOf(playerItem["chessPlayer"]) > -1;
				//如果棋手是需要忽略棋手，则直接剔除聊天内容，进入下一次解析
				if (isIgnorePlayer) {
					dataSource = dataSource.substring(index, dataSource.length);
					continue;
				}
				
				//非忽略棋手，解析聊天内容
				//如果没有日期，组合日期
				let createTime = playerItem["createTime"];
				if (!createTime) {
					playerItem["createTime"] = (playerItem["date"]?playerItem["date"]:date) + " " + (playerItem["time"]?playerItem["time"]:"09:00:00");
					delete playerItem["date"];
					delete playerItem["time"];
				}
				playerItem["createTime"] = playerItem["createTime"].replaceAll("/", "-");
				playerItem["source"] = this.currentSourceId;
				
				//解析棋招类型
				let demandType = this.analysisDemandType(productSource);
				
				//解析棋招
				let productItems = [];
				this.analysisProduct(playerItem, demandType, productItems, currentProductRegularDataJson, productSource);
				if (productItems.length == 0 && this.isSupportReplay && demandType != null){
					//没有匹配到产品，支持数据回复，且类型不为null 看看是否是对应前面数据的回复
					//看产品内容中是否有@
					let currentPlayerName = null;
					let aitIndex = productSource.indexOf("@");
					if (aitIndex > -1) {
						if (this.currentRegularType == 2) {
						//客渠混合时，@才针对产品，否则就是提醒作用
							let productSize = 1;
							//有@, 已有的结果中查找是否有 @棋手 能匹配上产品数据内容的,有则定位
							while (this.resultData.length - productSize >= 0 && productSize <= 100) {
								if (currentPlayerName != null && (this.resultData[this.resultData.length - productSize]["chessPlayer"] + this.resultData[this.resultData.length - productSize]["createTime"]) != currentPlayerName) {
									break;
								}
								if (productSource.indexOf("@"+this.resultData[this.resultData.length - productSize]["chessPlayer"] + " ") > -1) {
									currentPlayerName = this.resultData[this.resultData.length - productSize]["chessPlayer"] + this.resultData[this.resultData.length - productSize]["createTime"];
									this.supplementProduct(this.resultData[this.resultData.length - productSize], productItems, playerItem, demandType);
								}
								productSize ++;
							}
						}
					} else {
						//如果没有匹配到产品信息，聊天内容大于5个字，默认为闲聊记录
						if (productSource.length <= 5 && this.resultData.length > 0) {
							//没有@，且上一条数据的棋手和当前数据的棋手一样，默认为对上条数据回复
							if (this.resultData[this.resultData.length - 1]["chessPlayer"] != playerItem["chessPlayer"]) {
								currentPlayerName = this.resultData[this.resultData.length - 1]["chessPlayer"] + this.resultData[this.resultData.length - 1]["createTime"];
								for (var i = this.resultData.length - 1; i >= 0; i--) {
									if (currentPlayerName != (this.resultData[i]["chessPlayer"] + this.resultData[i]["createTime"])) {
										break;
									}
									this.supplementProduct(this.resultData[i], productItems, playerItem, demandType);
								}
							}
						}
					}
					
				}
				//匹配到数据，将数据写入结果中
				for (var i = 0; i < productItems.length; i++) {
					this.resultData.push(productItems[i]);
				}
				//解析过的数据清理掉，进入下一次解析
				dataSource = dataSource.substring(index, dataSource.length);
			}
		},
		supplementProduct(latestProduct, productItems, playerItem, demandType) {
			if (latestProduct != null) {
				//如果能找到对应数据，加一条
				let productItem = {};
				productItem["productName"] = latestProduct["productName"];
				productItem["chessPlayer"] = playerItem["chessPlayer"];
				productItem["createTime"] = playerItem["createTime"];
				productItem["demandType"] = demandType;
				productItem["rowStart"] = playerItem["rowStart"];
				productItem["rowEnd"] = playerItem["rowEnd"];
				productItems.push(productItem);
			}
		},
		//解析棋手信息
		recursionAnalysisPlayer(dataItem, regularJson, source, attributeName) {
			let result = null;
			let regularIndex = 0;
			while (regularIndex < regularJson.length) {
				//循环匹配，一个正则无法匹配所有数据
				result = source.match(regularJson[regularIndex][attributeName]["reg"]);
				if (result != null) {
					break;
				}
				regularIndex++;
			}
			if (result == null) {
				return "";
			}
			for(var i=0; i<result.length; i++) {
				//解析匹配结果
				let itemName = regularJson[regularIndex][attributeName]["data"][i];
				if (itemName) {
					let itemDataJson = regularJson[regularIndex][itemName];
					if (itemDataJson) {
						//如有内嵌解析，进入递归
						this.recursionAnalysisPlayer(dataItem, regularJson, result[i], itemName);
					} else {
						dataItem[itemName] = result[i];
					}
				}
			}
			if (result != null && regularIndex > 0) {
				//数据匹配成功，且非第一个正则匹配结果，切换正则顺序，一遍后续数据能在第一个正则匹配成功
				let temp = regularJson[0];
				regularJson[0] = regularJson[regularIndex];
				regularJson[regularIndex] = temp;
			}
			return result[0];
		},
		//定位下一个棋手信息位置
		searchPlayerIndex(source, regularJson) {
			let index = -1;
			for (var i=0; i<regularJson.length; i++) {
				index = source.search(regularJson[i]["main"]["reg"]);
				if (index > -1) {
					break;
				}
			}
			return index;
		},
		//递归解析产品
		analysisProduct(playerItem, demandType, productItems, regularDataJson, source) {
			let result = null;
			let regularIndex = 0;
			while (regularIndex < regularDataJson.length) {
				//循环匹配，一个正则无法匹配所有数据
				result = source.match(regularDataJson[regularIndex]["main"]["reg"]);
				if (result != null) {
					break;
				}
				regularIndex++;
			}
			if (result == null) {
				return;
			}
			let productItem = {}; 
			for (var item in playerItem) {
				productItem[item] = playerItem[item];
			}
			for(var i=0; i<result.length; i++) {
				let itemName = regularDataJson[regularIndex]["main"]["data"][i];
				if (itemName) {
					productItem[itemName] = result[i];
				}
			}
			//如果类型为null  但没有类型，默认为currentDemandType;
			productItem["demandType"]= (demandType==null?this.currentDemandType:demandType);
			//保存数据，进入递归
			productItems.push(productItem);
			let matchLen = source.indexOf(result[0]) + result[0].length;
			let data = source.substring(matchLen, source.length);
			this.analysisProduct(playerItem, demandType, productItems, regularDataJson, data);
		},
		//类型匹配
		analysisDemandType(productSource) {
			let result = null;
			let demandType = null;
			let matchData = null;
			for (var item in this.demandTypeMapping) {
				result = productSource.match(this.demandTypeMapping[item]);
				if (result != null) {
					if (matchData == null || (matchData != null && matchData.length < result[0].length)) {
						matchData = result[0];
						demandType = item;
					} 
				}
			}
			return demandType;
		},
		//列表双击事件
		tableDoubleClick(row, column, cell, event){
			let array = this.analysis.source.split("\n");
			let arraySize = array.length;
			let start = 0;
			//根据rowStart信息定位到内容开始匹配位置
			for (var i = 0; i < row.rowStart - 1; i++) {
				//+1是\n的长度
				start += array[i].length + 1;
			}
			let end = start;
			//根据rowEnd信息定位到内容结束匹配位置
			for (var i=row.rowStart - 1; i < row.rowEnd; i++) {
				end += array[i].length + 1;
			}
			let input = this.$refs.sourceTextArea;
			//选中行对应的元数据
			this.setSelectionRange(input, start, end);
			//滚动到原始数据前两行
			input.scrollTop = ((row.rowStart - 2) / arraySize) * input.scrollHeight;
		},
		//选中行对应的元数据
		setSelectionRange(input, selectionStart, selectionEnd) {
			if (input.setSelectionRange) {
				input.focus()
				input.setSelectionRange(selectionStart, selectionEnd)
			} else if (input.createTextRange) {
				const range = input.createTextRange()
				range.collapse(true)
				range.moveEnd('character', selectionEnd)
				range.moveStart('character', selectionStart)
				range.select()
			}
		},
		getCurrentDate() {
			var d = new Date()
			return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
		},
		saveBatch() {
			this.$confirm('确定要提交棋招记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					this.progressAge = 0;
					this.progressMax = this.resultData.length;
					this.submitIndex = 0;
					this.submitResultData = [];
					this.saveChessDemand(this.submitIndex);
				})
				.catch(() => {});
		},
		saveChessDemand(index) {
			this.submitIndex = index;
			let end = index + this.quantityPerTime;
			if (end > this.progressMax) {
				end = this.progressMax;
			}
			
			let submitData = {};
			submitData["from"] = this.from;
			submitData["key"] = this.key;
			submitData["items"] = this.resultData.slice(index, end);
			submitData["keys"] = this.keys;
			this.loading();
			saveChessDemandBatch(submitData).then(res => {
				if (res.code == 0) {
					if (end == this.progressMax) {
						this.$message.success('提交成功');
						this.resultData=this.submitResultData.concat(res.data);
						this.progressAge = 100;
						if (this.loadingForm) {
							this.loadingForm.close();
						}
					} else {
						this.submitResultData=this.submitResultData.concat(res.data);
						this.saveChessDemand(end);
					}
				} else {
					this.$message.error(`提交失败！` + res.message);
				}
			});
		},
		progressChange(message) {
			let data = JSON.parse(message.detail);
			if (this.progressAge < 100) {
				this.progressAge = Math.round((this.submitIndex + Number(data.data.content)) / this.progressMax * 100);
			}
		},
		loading() {
			this.loadingForm = this.$loading({
			  lock: true,
			  text: '提交中，请稍后...',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.7)'
			});
			setTimeout(() => {
			  this.loadingForm.close();
			}, 120000);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.edit-container {
  height: 570px;
  padding: 10px 20px;
}

.edit {
  display: flex;
  height: 530px;
}

.leftBox {
  width: 45px;
  height: 100%;
  text-align: left;
}

.area-content {
  padding: 10px 8px;
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 24px;
  color: #2dc26b;
  font-family: Consolas;
  border: none;
  background: #373737;
  box-sizing: border-box;
  outline: none;
  resize: none;
}

#leftNum {
  padding: 10px 4px;
  height: 100%;
  width: 100%;
  line-height: 24px;
  font-size: 13px;
  text-align: right;
  color: #fff;
  font-weight: bold;
  resize: none;
  outline: none;
  border: 0;
  background: black;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:600px;
	width:10px;
	position:absolute;
	margin-left:-15px;
	text-align:center;
	line-height:600px;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}
</style>
